import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/unstable/httpapi';
import { Schema } from 'effect';
import { BadRequestError, InternalServerError } from './errors';
import { SchemaUtils } from './schema-utils';

// `minLength(7)` used to let through anything digit-ish, which the helpdesk then
// rejected on format — every lead 500'd. E.164 is the rule Chatwoot actually
// enforces, so the contract now states it and clients normalize before sending.
//
// Phone is optional: Chatwoot allows a blank `phone_number`, and requiring a
// country-code-prefixed number on a lead form costs more leads than it captures.
// Omit the key entirely when the visitor leaves it blank — `''` is not E.164.
const SubmitPayload = Schema.Struct({
  email: SchemaUtils.Email,
  phone: Schema.optional(SchemaUtils.E164Phone),
});

// Provider-neutral response: the backend may route this to any helpdesk
// (Chatwoot today). Callers only need to know the lead was accepted, not which
// vendor record was created.
const SubmitResponse = Schema.Struct({
  submitted: Schema.Boolean,
});

const submitEndpoint = HttpApiEndpoint.post('Submit', '/', {
  payload: SubmitPayload,
  success: SubmitResponse.pipe(HttpApiSchema.status(200)),
  error: [BadRequestError, InternalServerError],
})
  .annotate(OpenApi.Summary, 'Submit Business Contact')
  .annotate(
    OpenApi.Description,
    'Submit a business lead inquiry to the support helpdesk',
  );

export const businessContactGroup = HttpApiGroup.make('BusinessContact')
  .add(submitEndpoint)
  .prefix('/business-contact');
